import * as React from 'react'
import { FormControlLabel, Switch, Typography } from '@mui/material'
import { themeNew } from 'styles/theme-new'

function CustomSwitch({
  value,
  label,
  onChange,
  isLoading,
  disabled,
  muted = false,
}: {
  value: boolean
  label: string
  onChange: () => void
  isLoading: boolean
  disabled?: boolean
  // Looks like a disabled switch but stays clickable (ENG2-2457).
  muted?: boolean
}) {
  return (
    <FormControlLabel
      sx={{
        m: 0,
        opacity: muted ? 0.6 : 1,
        '&:hover': muted ? { opacity: 1 } : undefined,
        '& .MuiFormControlLabel-label': {
          fontSize: '0.875rem',
        },
      }}
      control={
        <Switch
          size="small"
          disabled={disabled ? disabled : isLoading}
          color="default"
          style={{
            color: value
              ? themeNew.palette.success[500]
              : themeNew.palette.grey[600],
          }}
          checked={value}
          onChange={!isLoading ? onChange : undefined}
        />
      }
      label={
        <Typography
          variant="body2"
          color={value ? 'text.primary' : 'text.secondary'}
        >
          {label}
        </Typography>
      }
    />
  )
}

export default CustomSwitch
